import Vue from 'vue'

import { $themeConfig } from '@themeConfig'

const REPORTS_API_URL = `${$themeConfig.app.backUrl}/reports`

export function printReport(reportId, payload) {
    return Vue.axios.post(`${REPORTS_API_URL}/${reportId}/print`, payload)
}

export function getReportPreview(
    reportId,
    shiftId,
    divisionId,
    courierId = null,
    isPreview = true
) {
    const endpoint = isPreview ? `${reportId}/preview` : reportId
    const url = `${REPORTS_API_URL}/${endpoint}`

    const params = {
        shift_id: shiftId,
        division_id: divisionId,
        courier_id: courierId || undefined,
    }

    return Vue.axios.get(url, { params })
}

export function updateCourierSettlementReportOrder(orderId, payload) {
    const url = `${REPORTS_API_URL}/courier-settlement/${orderId}`

    return Vue.axios.put(url, payload)
}

export function fetchReports() {
    return Vue.axios.get(`${REPORTS_API_URL}`)
}
